module.exports = __webpack_public_path__ + "img/icon-quac-large_negro.9760562f.svg";